module.exports = __webpack_public_path__ + "static/cloud-small-df777a15bf4d0cde40cf7e460d7b2c44.png";